import { Injectable } from '@angular/core';
import { BaseServiceService } from '../base_service/base-service.service';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { UserInfo } from '../../services/payload/userInfo_pobj'
import { BehaviorSubject, Subject, Observable, ReplaySubject, from, throwError, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { StmgService } from '../../services/state_Management/stmg.service';
import { SlipBetDetails_pObj } from '../payload/slipbets_pobj';
import { StorageServicesService } from '../storage_services/storage-services.service';



@Injectable({
  providedIn: 'root'
})
export class UserServiceService {

  URL: string


  constructor(private baseService: BaseServiceService,
    private http: HttpClient,public storageService: StorageServicesService,
    private state: StmgService) {
    this.URL = this.baseService.baseUrl();
  }

  getUserInfo(data: any): Observable<UserInfo> {
    const url_user = this.URL + 'customer';
    const params_getUser = new HttpParams()
      .set('accountId', data.account)
    const responseObservable = this.http.get(url_user, {
      responseType: 'json',
      params: params_getUser,
      headers: new HttpHeaders()
        .set('Authorization', 'Token ' + data.token)
    })
      .pipe(
        map(rr => rr as UserInfo)
      )

    responseObservable.subscribe(info => {
      this.state.updateUserInfo(info);
    })
    return responseObservable
  }

  // update User Details
  updateUserInfo(data : any, token:string): Observable<any>{
    const url_cUpDetails = this.URL + 'customer/updateCustomerDetails'
    return this.http.post(url_cUpDetails,data,{
      headers: new HttpHeaders()
        .set('Authorization', 'Token ' + token)
    });
  }

  // get user transactions

  getUserTransactions(data: any): Observable<any> {
    const url_user = this.URL + 'customer/transactions';
    const params_getUser = new HttpParams()
      .set('accountId', data.accountNumber)
    return this.http.get(url_user, {
      responseType: 'json',
      params: params_getUser,
      headers: new HttpHeaders()
        .set('Authorization', 'Token ' + data.token)
    })
  }

  // get user bets
  getUserBets(data: any): Observable<[SlipBetDetails_pObj]> {
    //console.log(data);
    const url_user = this.URL + 'customer/myBets';
    const params_getUser = new HttpParams()
      .set('accountNumber', data.accountNumber)
      .set('lastSlipId', data.lastSlipId)
    return this.http.get(url_user, {
      responseType: 'json',
      params: params_getUser,
      headers: new HttpHeaders()
        .set('Authorization', 'Token ' + data.token)
    }).pipe(
      map(rr => rr as [SlipBetDetails_pObj])
    )
  }

    // get slips video url
    getVideoUrl(data: any): Observable<any> {
      const url_user = this.URL + 'meeting/eventStatus';
      const params_getUser = new HttpParams()
        .set('eventId', data.eventId)
      return this.http.get(url_user, {
        responseType: 'json',
        params: params_getUser,
        headers: new HttpHeaders()
          .set('Authorization', 'Token ' + data.token)
      })
    }

  // deposit
  deposit() {
    return this.URL + 'customer/initiateMPGS';
  }

  getPaymentSessionID(data: any): Observable<any> {
    const url_user = this.URL + 'customer/initiateMPGS';
    const params_getUser = new HttpParams()
      .set('vpc_Amount', data.amount)
      .set('vpc_Type', data.vpcType)
    return this.http.post(url_user, {}, {
      params: params_getUser,
      headers: new HttpHeaders()
        .set('Authorization', 'Token ' + data.token)
    })
  }

  // withdraw
  withdraw(data: any): Observable<any> {
    
    const url_user = this.URL + 'customer/withdraw_v2';
    const params_getUser = new HttpParams()
      .set('accountId', data.accountId)
      .set('amount', data.amount)
      .set('bankCode', data.bankCode)
      .set('branchCode', data.branchCode)
      .set('changeAC', data.changeAC)
      .set('pin', data.pin)
      .set('redeemAccountName', data.redeemAccountName)
      .set('withdrawFromBank', data.withdrawFromBank)
      .set('redeemAccount', data.redeemAccount)
      .set('ref', data.ref)
    return this.http.put(url_user, {}, {
      params: params_getUser,
      headers: new HttpHeaders()
        .set('Authorization', 'Token ' + data.token)
    })
  }

  // Get banks
  getBankList(): Observable<any> {
    const url_user = this.URL + 'bank/getBanks';
    const params_getUser = new HttpParams()
    const responseObservable = this.http.get(url_user, {
      responseType: 'json',
      params: params_getUser,
      headers: new HttpHeaders()
    })
    responseObservable.subscribe(info => this.state.updateBankList(info))
    return responseObservable
  }

  // Get bank branch
  getBranchList(data: any): Observable<any> {
    const url_user = this.URL + 'bank/getBranches';
    const params_getUser = new HttpParams()
    .set('bankCode', data.bankCode)
    const responseObservable = this.http.get(url_user, {
      responseType: 'json',
      params: params_getUser,
      headers: new HttpHeaders()
    })
    responseObservable.subscribe(info => this.state.updateBranchList(info))
    return responseObservable
  }

  getVideoEligibility( data: { meetingIds: number[]; token: string }): Observable<any> {

    if (data.meetingIds.some(id => !Number.isSafeInteger(id) || id <= 0)) {
      return throwError(() => new Error('Invalid event ID.'));
    }

    const uniqueIds = Array.from(new Set(data.meetingIds));

    if (uniqueIds.length === 0) {
      return of<any>({
        status: 'success',
        payload: []
      });
    }

    if (uniqueIds.length > 200) {
      return throwError(() => new Error('Request eligibility for at most 200 meetings at a time.'));
    }

    return this.http.post<any>(
      this.URL + 'customer/videoEligibility',
      { meetingIds: uniqueIds },
      { headers: new HttpHeaders().set('Authorization', 'Token ' + data.token) }
    );
  }

  // Check the customer's betting eligibility for this event.
  checkVideoEligibility(data: { meetingId: number; token: string }): Observable<any> {
    return this.http.get(this.URL + 'customer/isEligibilityForVideo',
      {
        params: new HttpParams().set('meetingId', String(data.meetingId)),
        headers: new HttpHeaders().set('Authorization', 'Token ' + data.token)
      }
    );
  }

  // Request video access when the customer clicks Play.
  getVideoAccess(data: { meetingId: number; token: string }): Observable<any> {
    return this.http.get(this.URL + 'customer/videoAccess',
      {
        params: new HttpParams().set('meetingId', String(data.meetingId)),
        headers: new HttpHeaders().set('Authorization', 'Token ' + data.token)
      }
    );
  }

}
